import React, { useMemo } from 'react';
import WorkOrderTable from '../WorkOrderTable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
	isSupplierPayingCustomer,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import {
	getWorkOrderArchivalKey,
	INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER,
	PAYING_SUPPLIER_WO_FILTER_ORDER,
	THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER,
} from '../../utils/WorkOrderUtils';
import posthog from 'posthog-js';
import WorkOrderFiltersWrapper from '../work_order_filters_wrapper/WorkOrderFiltersWrapper';
import { SUPPLIER_TECH } from '../roles/roles';
import { SUBCONTRACTED_FILTERS } from '../WorkOrderTable/config/subcontracted';
import { ASSIGNED_FILTERS } from '../WorkOrderTable/config/assigned';
import { ACTIVE_WORK_ORDER_TAB_FILTERS } from '../WorkOrderTable/config/tabFilters/tabFilters';

function WorkOrdersArchivedIndexPage({ currentUser }) {
	const isInternalTech = useMemo(
		() => nullSafeGetOrElse('facility.status', currentUser, '') === 'private',
		[currentUser]
	);

	const showMineAsInitialFilter =
		isInternalTech &&
		nullSafeGetOrElse('roles', currentUser, []).some((_) => _ === SUPPLIER_TECH) &&
		nullSafeGetOrElse(
			'facility.privateBuyerCompanySettings.config.workOrder.showOnlyAssignedWorkOrdersInDefaultTechnicianView',
			currentUser,
			false
		);
	const advancedFiltersConfig = useMemo(
		() =>
			isInternalTech
				? INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER
				: isSupplierPayingCustomer(currentUser)
				? PAYING_SUPPLIER_WO_FILTER_ORDER
				: THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER,
		[currentUser, isInternalTech]
	);

	const initialFilters = showMineAsInitialFilter
		? {
				assigned: 'me',
				supplierFacilityId: nullSafeGet('facility.id', currentUser),
				fieldTechnicianEmail: nullSafeGet('email', currentUser),
				notSupplierFacilityId: undefined,
		  }
		: {};

	const preAppliedFilters = {
		[getWorkOrderArchivalKey(currentUser)]: true,
	};
	return (
		<WorkOrderTable
			handleQueryParams
			preAppliedFilters={preAppliedFilters}
			filterConfig={{
				...(!isInternalTech && { subContractedFilters: SUBCONTRACTED_FILTERS(currentUser) }),
				assignedFilters: ASSIGNED_FILTERS(currentUser),
				tabFilters: ACTIVE_WORK_ORDER_TAB_FILTERS,
				filters: advancedFiltersConfig,
			}}
			targetCollectionName="archivedWorkOrdersIndex"
			initialFilters={initialFilters}
		/>
	);
}

export default withRouter(
	connect(
		(state) => ({
			currentUser: (state as any).session.currentUser,
		}),
		() => ({})
	)(WorkOrdersArchivedIndexPage)
);
